// More actions (overflow) builder — opens a small popover with the
// less-common actions (Copy text, Copy link, Report) that don't earn
// their own slot in the main bar. Like React, the popover lives in
// the host row; this builder only declares the ARIA relationship and
// a `buttonRef` for anchoring.

import type { Ref } from "react";
import { MoreHorizontal } from "lucide-react";

import type { MessageAction } from "~/components/MessageActions";

export function buildMoreAction(params: {
  menuOpen: boolean;
  onToggle: () => void;
  buttonRef?: Ref<HTMLButtonElement>;
}): MessageAction {
  return {
    id: "more",
    label: "More actions",
    icon: MoreHorizontal,
    onClick: params.onToggle,
    hasPopup: "menu",
    expanded: params.menuOpen,
    buttonRef: params.buttonRef,
  };
}
